import { FormattedMessage } from 'react-intl';
import React from 'react';
import bemify from 'bemify-js';

import BashCodeBlock from '../components/BashCodeBlock';
import Code from '../components/Code';
import Paragraph from '../components/Paragraph';
import StepTitle from '../components/StepTitle';

const bem = bemify('run-login');

const RunLogin = () => (
  <div className={bem()}>
    <StepTitle>
      <FormattedMessage
        defaultMessage="Run Zapier Login"
        id="headings-run-zapier-login"
      />
    </StepTitle>
    <Paragraph>
      <FormattedMessage
        defaultMessage="Let's configure authentication between your dev environment and the Zapier platform. You'll use the email address and password you use to log in to the Zapier application."
        id="descriptions-configure-authentication-between-dev-environment-and-platform"
      />
    </Paragraph>
    <BashCodeBlock
      lines={[
        {
          content: 'zapier login',
          isCommand: true,
        },
      ]}
    />
    <Paragraph>
      <FormattedMessage
        defaultMessage="This command will set up a"
        id="descriptions-login-command-creates-config-file-prefix"
      />{' '}
      <Code>
        <FormattedMessage
          defaultMessage=".zapierrc"
          id="labels-zapierrc-file"
        />
      </Code>{' '}
      <FormattedMessage
        defaultMessage="file in your home directory."
        id="descriptions-login-command-creates-config-file-suffix"
      />
    </Paragraph>
  </div>
);

export default RunLogin;
